module.exports = __webpack_public_path__ + "static/media/ic_day_emark_white.27973e04.svg";